/* eslint-disable react/prop-types */ // TODO: add props
import { Component, Fragment } from 'react';
import _ from 'lodash';
import urlResolver from 'edrolo/utils/URLResolver';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import GridSquare from './GridSquare';
import LessonTitle from './LessonTitle';
import { TallyAvg, TallyTitle } from './Tally';
import { buildAnonymizer } from 'edrolo/domains/anonymizer';
import { Table } from 'edrolo/domains/teacherResultsTable';
import style from './TopicGrid.scss';

class TopicGrid extends Component {
  state = {
    fetchingTopicProgressData: false,
    topicProgressDataError: false,
  };

  fetchTopicProgressData = () => {
    if (
      this.state.fetchingTopicProgressData ||
      this.state.topicProgressDataError
    ) {
      return;
    }
    const topicId = this.props.topicId;
    const url = urlResolver.reverse('api:class-topic-progress-detail', {
      classId: this.props.classId,
      topicId,
    });

    this.setState({ fetchingTopicProgressData: true }, () => {
      // TODO @danny #jquery
      $.ajax({
        url,
        dataType: 'json',
        success: (newClassProgressData) => {
          const newProgressDataObj = {};
          newProgressDataObj[topicId] = newClassProgressData;
          this.props.onFetchedTopicProgressData(newProgressDataObj, () => {
            this.setState({
              fetchingTopicProgressData: false,
              topicProgressDataError: false,
            });
          });
        },
        error: (xhr, status, err) => {
          // eslint-disable-next-line no-console
          console.error(url, status, err.toString());
          this.setState({
            fetchingTopicProgressData: false,
            topicProgressDataError: true,
          });
        },
      });
    });
  };

  componentDidMount() {
    analytics.track('viewed topic grid', {
      class_id: this.props.classId,
      topic_id: this.props.topicId,
    });

    // First mount - (on page load)
    if (!this.props.classProgressLoaded && !this.state.topicProgressDataError) {
      this.fetchTopicProgressData();
    }

    this.props.loadAssemblage(this.props.classId);
  }

  componentDidUpdate() {
    // Was in componentWillReceiveProps but Router doesn't trigger props changes since 0.11
    if (!this.props.classProgressLoaded && !this.state.topicProgressDataError) {
      this.fetchTopicProgressData();
    }
  }

  studentAnonymizer = buildAnonymizer({
    seedResolver: 'student_id',
    schemaFields: [{ key: 'student_name', type: 'full_name' }],
  });

  get allStudentResults() {
    const { isAnonymized } = this.props;
    let allStudentResults = this.props.classProgressData.student_results;

    if (isAnonymized) {
      allStudentResults = allStudentResults.map(this.studentAnonymizer);
    }

    allStudentResults = _.sortBy(allStudentResults, (student) => [
      student.student_name.split(' ')[1],
      student.student_name.split(' ')[0],
    ]);

    return allStudentResults;
  }

  render() {
    if (!this.props.classProgressLoaded) {
      return <LoadingIndicator loadingText="Loading Topic Progress" />;
    }

    // Navigate to new topic via react-router
    const lessons = this.props.topicLessons;

    if (!lessons.size) {
      return null;
    }

    const lessonTitles = lessons.map((lesson, i) => {
      return (
        <Table.ColHeader
          isSticky
          key={`lesson-title-${lesson.get('id')}`}
          className={style.LessonTitleColHeader}
          colSpan={3}
        >
          <LessonTitle
            lessonId={lesson.get('id')}
            title={lesson.get('title')}
            keyKnowledgeText={lesson.get('key_knowledge_text')}
            classId={this.props.classId}
          />
        </Table.ColHeader>
      );
    });

    const activeStudentResults = this.allStudentResults.filter(
      (studentResult) => {
        return studentResult && studentResult.student_is_active;
      }
    );
    const inactiveStudentResults = this.allStudentResults.filter(
      (studentResult) => {
        return studentResult && !studentResult.student_is_active;
      }
    );

    const tallies = this.props.topicLessons
      // first order the tallies by the true lesson order
      .map((lesson) =>
        _.find(
          this.props.classProgressData.tallies,
          (tally) => tally.lesson_id === lesson.get('id')
        )
      );

    const tallyAvgs = tallies.map((tally, i) => (
      <Fragment key={`lesson-${tally?.lesson_id}`}>
        <Table.ColHeader
          className={style.videosAvgHeader}
          key={`tally-videos-${tally?.lesson_id}`}
        >
          <TallyAvg
            type="videos"
            value={tally?.average_videos_watched}
            max={tally?.video_count}
          />
        </Table.ColHeader>
        <Table.ColHeader
          className={style.quizHeader}
          key={`tally-quizes-${tally?.lesson_id}`}
        >
          <TallyAvg
            type="quizzes"
            value={tally?.average_marks_obtained}
            max={tally?.marks_available}
          />
        </Table.ColHeader>
        <Table.ColHeader
          className={style.ratingAvgHeader}
          key={`tally-rating-${tally?.lesson_id}`}
        >
          <TallyAvg type="rating" value={tally?.average_self_rating} max={5} />
        </Table.ColHeader>
      </Fragment>
    ));

    const tallyTitles = tallies.map((tally) => (
      <Fragment key={`lesson-${tally?.lesson_id}`}>
        <Table.ColHeader
          className={style.videosTitleHeader}
          key={`tally-videos-${tally?.lesson_id}`}
        >
          <TallyTitle type="videos" />
        </Table.ColHeader>
        <Table.ColHeader
          className={style.quizHeader}
          key={`tally-quizes-${tally?.lesson_id}`}
        >
          <TallyTitle type="quizzes" />
        </Table.ColHeader>
        <Table.ColHeader
          className={style.ratingTitleHeader}
          key={`tally-rating-${tally?.lesson_id}`}
        >
          <TallyTitle type="rating" />
        </Table.ColHeader>
      </Fragment>
    ));

    const activeStudentResultRows = activeStudentResults.map(
      (studentTopicResult, i) => {
        const studentLessonResults = this.props.topicLessons
          // first order the results by the true lesson order
          .map((lesson) =>
            _.find(
              studentTopicResult.results,
              (result) => result.lesson_id === lesson.get('id')
            )
          )
          .map((result, j) => (
            <Fragment key={`lesson-${result?.lesson_id}`}>
              <Table.Cell
                className={style.videosCell}
                key={`lesson-videos-${result?.lesson_id}`}
              >
                <GridSquare
                  type="videos"
                  value={result?.videos_watched}
                  max={result?.video_count}
                  complete={result?.all_videos_watched}
                  classId={this.props.classId}
                  studentId={studentTopicResult.student_id}
                  lessonId={result?.lesson_id}
                />
              </Table.Cell>
              <Table.Cell
                className={style.ratingCell}
                key={`lesson-quizzes-${result?.lesson_id}`}
              >
                <GridSquare
                  type="quizzes"
                  value={result?.marks_obtained}
                  max={result?.marks_available}
                  complete={result?.marks_obtained === result?.marks_available}
                  classId={this.props.classId}
                  studentId={studentTopicResult.student_id}
                  lessonId={result?.lesson_id}
                />
              </Table.Cell>
              <Table.Cell
                className={style.quizzesCell}
                key={`lesson-rating-${result?.lesson_id}`}
              >
                <GridSquare
                  type="rating"
                  value={result?.self_rating}
                  max={5}
                  popoverContent={
                    _.isNull(result?.self_rating)
                      ? `${studentTopicResult.student_name} has not rated their understanding of this lesson`
                      : `${studentTopicResult.student_name} rates their understanding of this lesson as ${result?.self_rating}/5`
                  }
                  complete={result?.self_rating >= 5}
                />
              </Table.Cell>
            </Fragment>
          ));

        return (
          <Table.Row key={`student-${studentTopicResult.student_id}`}>
            <Table.RowHeader
              key={`student-name`}
              isSticky
              className={style.RowHeader}
            >
              {studentTopicResult.student_name}
            </Table.RowHeader>
            {studentLessonResults}
          </Table.Row>
        );
      }
    );

    const inactiveStudentResultRows = inactiveStudentResults.map(
      (studentTopicResult, i) => {
        return (
          <Table.Row key={`student-${studentTopicResult.student_id}`}>
            <Table.RowHeader
              key={`student-name`}
              isSticky
              className={style.RowHeader}
            >
              {studentTopicResult.student_name}
            </Table.RowHeader>
            <Table.Cell>pending</Table.Cell>
          </Table.Row>
        );
      }
    );

    return (
      <div className={style.tableContainer}>
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.ColHeader
                isSticky
                isHorizSticky
                className={style.LessonTitleColHeader}
                key="empty-header"
              />
              {lessonTitles}
            </Table.Row>
            <Table.Row>
              <Table.ColHeader isHorizSticky key="empty-header" />
              {tallyTitles}
            </Table.Row>
            <Table.Row>
              <Table.ColHeader isHorizSticky key="empty-header" />
              {tallyAvgs}
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {activeStudentResultRows}
            {inactiveStudentResultRows}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default TopicGrid;
